import React from 'react';

const ManagerInfo = ({ data }) => (
    <section>
        <div className="flex mt-10">
            <div>
                <h2 className="text-xl text-[#0a1445] font-bold mb-5">Manager Comp Info</h2>
            </div>
        </div>

        {Object.keys(data).length > 1 && (
            <div className="grid grid-cols-8 justify-between items-center gap-2 p-4 bg-white shadow-inner border-t-2 border-blue-200 rounded-lg mb-2">
                <p className="col-span-2 text-md font-medium text-indigo-600 truncate">{data.firstName} {data.lastName}</p>
                <p className="col-span-3 text-md text-gray-500 truncate">{data.email}</p>
                <p className="col-span-2 text-md text-gray-500 truncate">{data.title}</p>
            </div>
        )}
    </section>
);

export default ManagerInfo;
